export const fontWeight = {
  regular: '400',
  medium: '600',
  bold: '800',
};
